import { addStyles } from 'ethcss'
import { grid, item, textSizes, palette, radius } from 'theme'
import { defaultThemeStyles } from 'blocks.app/app/app.theme.jcss'

const uiStyles = {
    wrapper: {
        '& *': {
            fontFamily: `var(--var-module-app-component-app-style-fontFamily, ${defaultThemeStyles.fontFamily})`,
        },
    },
    blockPanel: {
        ...grid.mb_md,
        ...item.panel,
    },
    title: {
        ...grid.p_mini,
        fontSize: textSizes.md,
        fontWeight: 'bold',
    },
    content: {
        ...grid.row,
        ...grid.p_mini,
    },
    list: {
        ...grid.ml_mini,
        '& li': {
            ...grid.p_micro,
        },
        '& span': {
            fontWeight: 'bold',
        },
    },
    paletteContent: {
        ...grid.p_mini,
        display: 'flex',
        flexDirection: 'column',
        gap: 20,
    },
    scaleRow: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
    },
    scaleTitle: {
        fontSize: 14,
        fontWeight: 700,
        color: palette.neutral[700],
    },
    scaleSwatches: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 8,
    },
    swatch: {
        width: 72,
        textAlign: 'center',
    },
    swatchSquareWrap: {
        borderRadius: radius.small,
        overflow: 'hidden',
        border: `1px solid ${palette.neutral[300]}`,
        background: palette.neutral[0],
    },
    swatchSquareWrapDark: {
        background: palette.neutral[900],
        borderColor: palette.neutral[800],
    },
    swatchSquare: {
        width: '100%',
        height: 56,
    },
    swatchStep: {
        marginTop: 6,
        fontSize: 12,
        fontWeight: 500,
        color: palette.neutral[700],
    },
    tokenHint: {
        fontSize: 10,
        color: palette.neutral[500],
        wordBreak: 'break-all',
    },
    radiusRow: {
        ...grid.p_mini,
        display: 'flex',
        flexWrap: 'wrap',
        gap: 16,
    },
    radiusItem: {
        width: 88,
        textAlign: 'center',
    },
    radiusBox: {
        width: 72,
        height: 72,
        margin: '0 auto',
        background: palette.brandBlue[700],
    },
    shadowSection: {
        ...grid.p_mini,
        display: 'flex',
        flexDirection: 'column',
        gap: 24,
    },
    shadowSectionDark: {
        padding: 16,
        borderRadius: radius.medium,
        background: palette.neutral[900],
    },
    shadowSectionDarkTitle: {
        fontSize: 14,
        fontWeight: 700,
        color: palette.neutral[300],
    },
    shadowSectionDarkStep: {
        marginTop: 6,
        fontSize: 12,
        fontWeight: 500,
        color: palette.neutral[400],
    },
    shadowRow: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 24,
        marginTop: 12,
    },
    shadowItem: {
        textAlign: 'center',
    },
    shadowBox: {
        width: 120,
        height: 120,
        borderRadius: radius.large,
        background: palette.neutral[0],
    },
    shadowBoxDark: {
        background: palette.neutral[850],
    },
}

addStyles(uiStyles)
export default uiStyles
